module.exports = __webpack_public_path__ + "img/senior-designer-preview.b692fe5a.jpg";